/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddApiKeyRequest,
  Cadence,
  CadenceState,
  InitiateOAuthResult,
  MapCadenceIdCadence,
  MapSalesloftUserIdSalesloftUser,
  MapString,
  OptionSalesloftProspect,
  PaginatedResultCadence,
  PaginatedResultCadenceStep,
  PaginatedResultSalesloftUser,
  SalesloftUser,
  WrappedCredentialView,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "salesloft";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @tags OAuth
   * @name SalesloftOAuthCallback
   * @request GET:/v1/public/oauth/callback
   */
  salesloftOAuthCallback = (
    query: {
      state: string;
      /** @pattern [^\s\\/]+ */
      code?: string;
      /** @pattern [^\s\\/]+ */
      context?: string;
      /** @pattern [^\s\\/]+ */
      scopes?: string;
      /** @pattern [^\s\\/]+ */
      error?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for salesloftOAuthCallback */
  salesloftOAuthCallbackPathGetter = (query: {
    state: string;
    /** @pattern [^\s\\/]+ */
    code?: string;
    /** @pattern [^\s\\/]+ */
    context?: string;
    /** @pattern [^\s\\/]+ */
    scopes?: string;
    /** @pattern [^\s\\/]+ */
    error?: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);

  /**
   * No description
   *
   * @tags OAuth
   * @name InitiateSalesloftOAuthFlow
   * @request GET:/v1/tenant/{tenantId}/oauth/initiate
   * @secure
   */
  initiateSalesloftOAuthFlow = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      InitiateOAuthResult,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/initiate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateSalesloftOAuthFlow */
  initiateSalesloftOAuthFlowPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/oauth/initiate`);

  /**
   * No description
   *
   * @tags Credentials
   * @name GetSalesloftCredentialView
   * @request GET:/v1/tenant/{tenantId}/credential/organization
   * @secure
   */
  getSalesloftCredentialView = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      WrappedCredentialView,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential/organization`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesloftCredentialView */
  getSalesloftCredentialViewPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential/organization`);

  /**
   * No description
   *
   * @tags Credentials
   * @name UpsertSalesloftApiKey
   * @request POST:/v1/tenant/{tenantId}/credential/organization
   * @secure
   */
  upsertSalesloftApiKey = (tenantId: string, data: AddApiKeyRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential/organization`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertSalesloftApiKey */
  upsertSalesloftApiKeyPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential/organization`);

  /**
   * No description
   *
   * @tags Credentials
   * @name DeleteSalesloftCredential
   * @request DELETE:/v1/tenant/{tenantId}/credential/organization
   * @secure
   */
  deleteSalesloftCredential = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential/organization`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteSalesloftCredential */
  deleteSalesloftCredentialPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential/organization`);

  /**
   * No description
   *
   * @tags Cadence
   * @name ListCadences
   * @request GET:/v1/tenant/{tenantId}/cadences-list
   * @secure
   */
  listCadences = (
    tenantId: string,
    query?: {
      /**
       * $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updated_at:DESC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultCadence,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/cadences-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listCadences */
  listCadencesPathGetter = (
    tenantId: string,
    query?: {
      /**
       * $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updated_at:DESC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/cadences-list`, query);

  /**
   * No description
   *
   * @tags Cadence
   * @name CadenceById
   * @request GET:/v1/tenant/{tenantId}/cadences/{cadenceId}
   * @secure
   */
  cadenceById = (tenantId: string, cadenceId: number, params: RequestParams = {}) =>
    this.request<
      Cadence,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/cadences/${cadenceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cadenceById */
  cadenceByIdPathGetter = (tenantId: string, cadenceId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/cadences/${cadenceId}`);

  /**
   * No description
   *
   * @tags Cadence
   * @name CadencesByIds
   * @request GET:/v1/tenant/{tenantId}/cadences
   * @secure
   */
  cadencesByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapCadenceIdCadence,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/cadences`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cadencesByIds */
  cadencesByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/cadences`, query);

  /**
   * @description note: sadly salesloft does not allow to sort by other fields than created_at and updated_at it would be much preferred to sort by stepNumber: ASC
   *
   * @tags Cadence
   * @name CadenceStepsForCadence
   * @request GET:/v1/tenant/{tenantId}/cadence-steps/cadence-id/{cadenceId}
   * @secure
   */
  cadenceStepsForCadence = (
    tenantId: string,
    cadenceId: number,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultCadenceStep,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/cadence-steps/cadence-id/${cadenceId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cadenceStepsForCadence */
  cadenceStepsForCadencePathGetter = (
    tenantId: string,
    cadenceId: number,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/cadence-steps/cadence-id/${cadenceId}`, query);

  /**
   * No description
   *
   * @tags Prospect
   * @name FindProspect
   * @request GET:/v1/tenant/{tenantId}/prospect/by-email-ior-id
   * @secure
   */
  findProspect = (
    tenantId: string,
    query?: {
      /** @pattern .+@.+ */
      email?: string;
      /** @pattern [^\s\\/]+ */
      salesloftCrmId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      OptionSalesloftProspect,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/prospect/by-email-ior-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findProspect */
  findProspectPathGetter = (
    tenantId: string,
    query?: {
      /** @pattern .+@.+ */
      email?: string;
      /** @pattern [^\s\\/]+ */
      salesloftCrmId?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/prospect/by-email-ior-id`, query);

  /**
   * No description
   *
   * @tags User
   * @name ListUsers
   * @request GET:/v1/tenant/{tenantId}/users-list
   * @secure
   */
  listUsers = (
    tenantId: string,
    query?: {
      /**
       * $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updated_at:DESC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesloftUser,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listUsers */
  listUsersPathGetter = (
    tenantId: string,
    query?: {
      /**
       * $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updated_at:DESC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users-list`, query);

  /**
   * No description
   *
   * @tags User
   * @name UserById
   * @request GET:/v1/tenant/{tenantId}/users/{userId}
   * @secure
   */
  userById = (tenantId: string, userId: number, params: RequestParams = {}) =>
    this.request<
      SalesloftUser,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for userById */
  userByIdPathGetter = (tenantId: string, userId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/${userId}`);

  /**
   * No description
   *
   * @tags User
   * @name UsersByIds
   * @request GET:/v1/tenant/{tenantId}/users
   * @secure
   */
  usersByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapSalesloftUserIdSalesloftUser,
      | CadenceState
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for usersByIds */
  usersByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users`, query);
}
